import { Menu, MenuItem, TextField } from "@mui/material";
import { TagColorKind } from "generated/graphql";
import { HTMLProps, useState } from "react";
import { useAppSelector } from "redux/hooks";
import { selectLensEditorTagColors } from "redux/slices/lensEditor";
import { TagCellContext } from "./types";
const slugify = (s: string) => s.toLowerCase().replace(/\s+/g, "_");

export function ColorSwatch(props: HTMLProps<HTMLSpanElement>) {
  return <span {...props} className="rounded-full h-4 w-4 min-w-4 min-h-4 inline-block" />;
}

interface ColorPickerProps extends HTMLProps<HTMLSpanElement> {
  onSelectColor: (color: TagColorKind, colorValue: string) => void;
  editing: boolean;
}
function ColorPicker({ onSelectColor, editing, ...props }: ColorPickerProps) {
  const tagColors = useAppSelector(selectLensEditorTagColors);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = editing && !!anchorEl;

  const handleClose = () => setAnchorEl(null);
  return (
    <>
      <ColorSwatch
        title={editing ? "" : "Edit to change the color"}
        {...props}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      />
      <Menu anchorEl={anchorEl} open={open} onClose={handleClose} MenuListProps={{ className: "grid grid-cols-2" }}>
        {tagColors.map((color) => (
          <MenuItem
            key={color.value}
            title={color.displayName}
            onClick={() => {
              onSelectColor(color.color, color.value);
              handleClose();
            }}>
            <ColorSwatch style={{ backgroundColor: color.value }} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}

export function TagName({ row, isEditing, setIsEditing, updateTag, onSave }: TagCellContext<string>) {
  const editing = isEditing(row.id);
  const tag = row.original;

  return (
    <span
      className="w-full justify-between inline-flex items-center gap-1"
      onClick={() => !editing && setIsEditing(row.id)}>
      {editing ? (
        <TextField
          autoFocus
          variant="standard"
          className="bg-white p-0 focus:ring-peri-300"
          value={tag.displayName}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              onSave(tag);
            }
          }}
          onChange={(e) =>
            updateTag({
              ...tag,
              displayName: e.target.value,
              // Because this is used as id in several places we don't want to actually set the system name
              // TagSystemName component will see the temp value and display that instead
              tempSystemName: tag.isNewTag ? slugify(e.target.value) : tag.systemName,
            })
          }
        />
      ) : (
        <span className="py-1">{tag.displayName}</span>
      )}
      <ColorPicker
        editing={editing}
        onSelectColor={(color, colorValue) => {
          updateTag({ ...tag, color, colorValue });
        }}
        style={{ backgroundColor: tag.colorValue }}
      />
    </span>
  );
}
